import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject;
var RootStyles = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-width: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: ", ";\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return "-".concat(theme.sizing.xxtiny);
});

export { RootStyles as default };
//# sourceMappingURL=ScreenReaderOnly.styles.js.map
